export default{
  token: state => state.user.token
}